import { CELL_MIN_WIDTH } from './getStyling';

export const getCellWidth = (getSize: () => number): number => getSize() ?? CELL_MIN_WIDTH;

export const sanitizeId = (id: string) => id?.replace(/[^a-zA-Z0-9]/g, '');
